import { mapGetters } from "vuex"

import string_utilities from "./StringUtilities"

const project_utilities = {
    mixins: [string_utilities],
    methods: {
        role_for_project (project, user = this.profile) {
            if(user && (typeof user === "object")) user = user.id
            if(!!project && !!user) {
                if(project.pic_id === user) return "PIC"
                if(project.pm_id === user) return "PM"
                return "D"
            }
            return ""
        },
        pic_for_project (project) {
            if(!!project && !!project.pic_id && this.raw_user_records) {
                return this.raw_user_records.find(user => user.id === project.pic_id)
            }
            return null
        },
        pm_for_project (project) {
            if(!!project && !!project.pm_id && this.raw_user_records) {
                return this.raw_user_records.find(user => user.id === project.pm_id)
            }
            return null
        },
        project_is_active (project) {
            return !!project && !!project.activated_at
        },
        project_is_overhead (project) {
            return !!project && !!project.internal
        },
        proposals_for_project_id (project_id) {
            return this.raw_proposal_records.filter(proposal => proposal.project_id === project_id)
        },
        project_has_accepted_proposal (project_id) {
            return this.proposals_for_project_id(project_id).find(proposal => !!proposal.accepted_at)
        },
        project_status_label (project_status) {
            return this.term_value_by(project_status, "project_status").replace(/^-\s+(.+)\s+-$/, "$1")
        },
        project_users_for_project_id (project_id) {
            return this.raw_project_user_records.filter(project_user => project_user.project_id === project_id)
        },
        users_for_project_id (project_id) {
            return this.project_users_for_project_id(project_id).map(project_user => {
                return this.entity_record("user", project_user.user_id)
            }).filter(user => !!user)
        },
        team_member_for_project_id (user_id, project_id) {
            return this.raw_project_user_records.find(project_user => (project_user.user_id === user_id) && (project_user.project_id === project_id))
        },
        user_can_be_pic (user) {
            return !!user && ((user.role === this.$root.constants.roles.ASSOCIATE_PRINCIPAL.id) || (user.role === this.$root.constants.roles.PRINCIPAL.id))
        },
        user_can_be_pm (user, flexible = false) {
            return !!user && (user.role <= (flexible ? this.$root.constants.roles.ADMIN.id : this.$root.constants.roles.PRINCIPAL.id))
        }
    },
    computed: {
        ...mapGetters(["entity_records", "entity_record"]),
        raw_user_records () {
            return this.entity_records("user").filter(user => {
                return !user.deleted_at
            })
        },
        raw_project_user_records () {
            return this.entity_records("project_user")
        },
        raw_proposal_records () {
            return this.entity_records("proposal")
        },
        pics () {
            return this.raw_user_records.filter(user => this.user_can_be_pic(user))
        },
        pms (flexible = false) {
            return this.raw_user_records.filter(user => this.user_can_be_pm(user, flexible))
        }
    }
}

export default project_utilities
